import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/number.ts
function number(title, options = {}) {
	return Type.Number({
		title,
		...options
	});
}

//#endregion
export { number };
//# sourceMappingURL=number.js.map